var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestEventGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/calander") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CleverSparky-Web-App-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Test-Events-Populated",
    transform: "translate(-245.000000, -278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(237.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/calander",
    transform: "translate(0.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Calander",
    transform: "translate(9.000000, 9.000000)",
    stroke: "#666162",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3809833,11.14295 C12.3809833,11.4831167 12.1022056,11.7618944 11.7620389,11.7618944 L0.618872222,11.7618944 C0.278705556,11.7618944 -7.2222223e-05,11.4831167 -7.2222223e-05,11.14295 L-7.2222223e-05,1.85733889 C-7.2222223e-05,1.51645 0.278705556,1.23839444 0.618872222,1.23839444 L11.7620389,1.23839444 C12.1022056,1.23839444 12.3809833,1.51645 12.3809833,1.85733889 L12.3809833,11.14295 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99209444,0 L2.99209444,1.75427778",
    id: "Stroke-3",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38910556,0 L9.38910556,1.75427778",
    id: "Stroke-5",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.309833333,4.13551667 L12.0712222,4.13551667",
    id: "Stroke-7"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestEventGrey);
export default __webpack_public_path__ + "static/media/test-event-grey.d0da316527a2fc1def81ea59fa26c1d6.svg";
export { ForwardRef as ReactComponent };